// React imports.
import React, { Component } from "react";

// App imports.
import Assessment3aMainTable from "./Assessment3aMainTable";
import Assessment3aTopParagraph from "./Assessment3aTopParagraph";
import Assessment3aQuestions from "./Assessment3aQuestions";
import Assessment3aDownloadCSV from "./Assessment3aDownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment3aStepsEnum } from "../state";
import { Assessment3aVendorAssignedStatusEnum } from "../state";

//ResultsOverview=1,
//ResultsDetailElectric=2,
//ResultsDetailNaturalGas=3,
//ResultsDetailFuelOil=4,
//ResultsDetailPropane=5,
//ActionPlanSummary=6,

const Assessment3a = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.EnterDataNumHouseholds &&
          <div>
              <p><strong><u>Step 1:</u>  Enter the Number of Assisted Households by Fuel Type</strong></p>
              <p>
                  In order to establish a baseline for comparison, the first step of Assessment #3A is to record
                  the number of your LIHEAP-assisted clients that use each type of main heating fuel in the year
                  you are evaluating.
              </p>
              {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric != null
              && <p>
                  You report the total number of LIHEAP-assisted households by fuel type in your annual
                  Performance Measures Form. Since you are evaluating a program year for which the data
                  have already been processed, we have auto-populated this information in the table below.
              </p>}
              {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric == null
                && <p>
                    You report the total number of LIHEAP-assisted households by fuel type in your annual
                    Performance Measures Form. However, since you are evaluating a program year for which the
                    data have NOT already been processed, you must enter the necessary information from Section V,
                    Line A of your most current Performance Data Form. 
              </p>}
              <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler} holder={state.Assessment3aFuelTypesStatus} step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]} state={state} />
              <TableLegendLeft />
              <br />
          </div>
          }
          {(state.CurrentAssessementStepIndex == Assessment3aStepsEnum.EnterDataNumHouseholdsVendorAssigned)
              &&
              <div>
                  <p><strong><u>Step 2:</u>   Number of Households Assigned to an Electric Vendor</strong></p>
                  The next step of Assessment #3A is to record the number of assisted households  
                  that have been assigned to an electric vendor in your database. In order to fill out
                  your Performance Data Form Module 2, you need to collect each household’s electricity
                  supplier and the households account number with that electricity vendor. Since this
                  is a required data field, you should try to collect this information from at
                  least  95%  of the households that you serve. 
                  <br/><br/>
                  It is possible that some of your households may not have an electric vendor
                  and account number on file because they do not use electricity or have some
                  way to generate their own electricity. If you have any such households they
                  should NOT be counted as having an electric vendor or account number on file.
                  However, even if you have some households like this you should still have a
                  vendor and account number on file for at least 95% of your LIHEAP-assisted
                  households.
                  <br/><br/>
                  Please note that you do not report the number of assisted households that have been
                  assigned to an electric vendor in your Performance Data Form. So, you will
                  have to ask your IT staff to generate those numbers.
                  <br/><br/>

                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler} holder={state.Assessment3aFuelTypesStatus} step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }
          {(state.CurrentAssessementStepIndex == Assessment3aStepsEnum.VendorAssignedStatus)
              &&
              <div>
                  <p><strong><u>Step 3:</u>   Vendor Assignment Results Overview</strong></p>
                  Now that you have provided the necessary information, we can check to see  
                  if you have enough households assigned to a baseload electric vendor in your
                  database. The table below shows an overview of your results. Each fuel type
                  will be flagged for a potential data reliability issue if less than 95% of
                  households have an electric vendor listed on file.
                  <br/><br/>
                  These results are explored more thoroughly for each fuel type in Steps 3a-3d.
                  <br/><br/>
                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler} holder={state.Assessment3aFuelTypesStatus} step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]} state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.VendorAssignedFollowupElectric &&
              <div>
                  <p>
                      <strong><u>Step 3a:</u>  Results – Electric Households</strong>
                  </p>
                  <Assessment3aTopParagraph state={state}  fuelType={state.Assessment3aFuelTypesStatus.Electric} />
                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler}
                                          holder={state.Assessment3aFuelTypesStatus}
                                          step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3aQuestions state={state}  fuelType={state.Assessment3aFuelTypesStatus.Electric} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.VendorAssignedFollowupNaturalGas &&
              <div>
                  <p>
                      <strong><u>Step 3b:</u>  Results –  Natural Gas Households</strong>
                  </p>
                  <Assessment3aTopParagraph state={state}  fuelType={state.Assessment3aFuelTypesStatus.NaturalGas} />
                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler}
                                          holder={state.Assessment3aFuelTypesStatus}
                                          step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3aQuestions state={state}  fuelType={state.Assessment3aFuelTypesStatus.NaturalGas} />
                  <br />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.VendorAssignedFollowupFuelOil &&
              <div>
                  <p>
                      <strong><u>Step 3c:</u>  Results –  Fuel Oil Households</strong>
                  </p>
                  <Assessment3aTopParagraph state={state}  fuelType={state.Assessment3aFuelTypesStatus.FuelOil} />
                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler}
                                          holder={state.Assessment3aFuelTypesStatus}
                                          step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3aQuestions state={state}  fuelType={state.Assessment3aFuelTypesStatus.FuelOil} />
                  <br />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.VendorAssignedFollowupPropane &&
              <div>
                  <p>
                      <strong><u>Step 3d:</u>  Results –  Propane Households</strong>
                  </p>
                  <Assessment3aTopParagraph state={state}  fuelType={state.Assessment3aFuelTypesStatus.Propane} />
                  <Assessment3aMainTable  fieldChangeHandler={state.assessment3aFieldChangeHandler}
                                          holder={state.Assessment3aFuelTypesStatus}
                                          step={state.Assessment3aSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3aQuestions state={state}  fuelType={state.Assessment3aFuelTypesStatus.Propane} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 4:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #3A. Your aggregated  
                      action plan for every issue identified in Assessment #3A is included in the  
                      table below. You can now download or print the Assessment #3A action plan  
                      below. Also, you can revisit this page at any time by selecting it from  
                      the list of completed assessments on the Assessment Tool Selection Page.
                  </p>
                  <p>
                      Now that you have completed Assessment #3A, we strongly recommend that you
                      continue on to Assessment #3B. To this, simply click the "Finish &amp; Save"
                      button and you will be returned to the Assessment Selection page. From
                      there you can begin Assessment #3B.
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment3aGetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment>
                                  {!(state.showActionPlan(fuel))
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td colSpan={2}>N/A</td>
                                  </tr>}
                                  {(state.showActionPlan(fuel))
                                  &&
                                  <React.Fragment>
                                  {(fuel.appIncludesVendorAndAcctNoFlag === "N"
                                    ||fuel.appIncludesVendorAndAcctNoFlag === "U")
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          The LIHEAP application should ask for the vendor and account number of all applicants.
                                      </td>
                                      <td>
                                          {fuel.appIncludesVendorAndAcctNoDesc}
                                      </td>
                                  </tr>}
                                  {(fuel.appVendorAndAcctNoRequiredFieldFlag === "N"
                                    ||fuel.appVendorAndAcctNoRequiredFieldFlag === "U")
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          The LIHEAP application should make clear that electric vendor and account number are required fields for all applicants.
                                      </td>
                                      <td>
                                          {fuel.appVendorAndAcctNoRequiredFieldDesc}
                                      </td>
                                  </tr>}
                                  {(fuel.intakeFollowupMissingVendorFlag === "N"
                                    ||fuel.intakeFollowupMissingVendorFlag === "U")
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          Staff at intake agencies should be instructed to follow up with all applicants who fail to provide vendors and account numbers.
                                      </td>
                                      <td>
                                          {fuel.intakeFollowupMissingVendorDesc}
                                      </td>
                                  </tr>}
                                  {(fuel.otherReasonDesc != ""
                                    && fuel.otherReasonDesc != null)
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          Ideas about what might be causing the discrepancy.
                                      </td>
                                      <td>
                                          {fuel.otherReasonDesc}
                                      </td>
                                  </tr>}
                                  </React.Fragment>
                                  }
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
          <br />
          <button className="dataButton"
              onClick={() => state.assessment3aShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment3aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3aShowNextStep()}
                  disabled={state.Assessment3aShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment3aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3aShowActionPlan()}
                  disabled={state.Assessment3aShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment3aStepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment3aStepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment3aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment3aStepsEnum.ActionPlanSummary
          &&
            <Assessment3aDownloadCSV fuelTypes={[state.Assessment3aFuelTypesStatus.Electric,state.Assessment3aFuelTypesStatus.NaturalGas, state.Assessment3aFuelTypesStatus.FuelOil, state.Assessment3aFuelTypesStatus.Propane]}/>
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment3a;
